<template>
  <v-scale-transition>
    <wide-panel
      :title="title"
    >
      <v-toolbar flat>
        <v-menu
          v-model="monthMenu"
          :close-on-content-click="false"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="month"
              prepend-icon="mdi-calendar-outline"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="month"
            min="2020-11"
            :max="thisMonth"
            type="month"
            no-title
            @input="monthMenu = false"
          />
        </v-menu>
        <v-spacer />
        <v-autocomplete
          v-if="signageAdmin"
          v-model="location"
          :items="locationItems"
          label="Select or type location"
          item-text="location"
          item-value="code"
          prepend-icon="mdi-city"
          return-object
        >
          <template #item="data">
            <v-list-tile-content>
              <v-list-tile-title>{{ data.item.location }}, {{ data.item.leadDealer }} </v-list-tile-title>
              <!-- <v-list-tile-sub-title>{{ data.item.leadDealer }}, {{ data.item.pic }}, {{ data.item.contact }}</v-list-tile-sub-title> -->
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </v-toolbar>
      <v-subheader>Activations</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          :disabled="signageAdmin && !location"
          @click="exportTracking('activation')"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="activationHeaders"
        :items="activations"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <!-- ✅ Day -->
          <td class="text-xs-center">
            {{ props.item.day }}
          </td>

          <!-- ✅ Dynamic plans -->
          <td
            v-for="plan in dynamicPlans"
            :key="plan"
            class="text-xs-center"
          >
            {{ props.item[plan] }}
          </td>

          <!-- ✅ Total -->
          <td class="text-xs-right primary">
            {{ props.item.total }}
          </td>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Sub-total:
            </td>
            <td
              v-for="plan in dynamicPlans"
              :key="plan"
              class="text-xs-center primary--text"
            >
              {{ totals[plan] }}
            </td>
            <td class="text-xs-right primary">
              {{ totalActivation }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-subheader>Reloads</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          :disabled="signageAdmin && !location"
          @click="exportTracking('reload')"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="reloadHeaders"
        :items="reloads"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-center">
              {{ props.item.day }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailReloadHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.reload }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ Number(totalReload).toFixed(2) }}
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- <v-subheader>Recruitments</v-subheader>
      <v-sheet>
        <v-btn
          absolute
          dark
          fab
          small
          top
          right
          color="light-green"
          @click="exportTracking(recruitments)"
        >
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-sheet>
      <v-data-table
        :headers="recruitmentHeaders"
        :items="recruitments"
        :expand="expand"
        :loading="loading"
        item-key="day"
        class="elevation-1"
      >
        <template #items="props">
          <tr
            :active="props.selected"
            @click="props.expanded = !props.expanded"
          >
            <td class="text-xs-center">
              {{ props.item.day }}
            </td>
            <td class="text-xs-center primary">
              {{ props.item.total }}
            </td>
          </tr>
        </template>
        <template #expand="props">
          <v-sheet color="grey">
            <v-container>
              <v-layout row>
                <v-flex x12>
                  <v-data-table
                    :headers="detailRecruitmentHeaders"
                    :items="props.item.items"
                    item-key="dealer"
                    class="elevation-1"
                  >
                    <template #items="dealerProps">
                      <tr>
                        <td class="text-xs-left">
                          {{ dealerProps.item.dealer }}
                        </td>
                        <td class="text-xs-center primary">
                          {{ dealerProps.item.recruitment }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-sheet>
        </template>
        <template #footer>
          <tr>
            <td class="text-xs-right">
              Total:
            </td>
            <td class="text-xs-center primary">
              {{ totalRecruitment }}
            </td>
          </tr>
        </template>
      </v-data-table> -->
    </wide-panel>
  </v-scale-transition>
</template>

<script>
import { DateTime } from 'luxon'
import { createGetParams } from '@/rest'
import security from '@/security'
import * as XLSX from 'xlsx'

export default {
  components: {
    WidePanel: () => import(/* webpackChunkName: "widePanel" */ '@/components/WidePanel'),
  },
  data () {
    return {
      month: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL'),
      today: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL-dd'),
      thisMonth: DateTime.local().setZone('Asia/Kuala_Lumpur').toFormat('yyyy-LL'),
      expand: false,
      monthMenu: false,
      loading: false,
      title: 'Track Monthly',
      location: null,
      locations: [],
      allLocationsData: [],
      activationHeaders: [],
      activations: [],
      reloads: [],
      recruitments: [],
      dynamicPlans: [],
      totals: [],
      // activationHeaders: [
      //   {
      //     text: 'Day',
      //     align: 'center',
      //     sortable: true,
      //     value: 'day',
      //   },
      //   {
      //     text: 'Prepaid',
      //     align: 'center',
      //     sortable: true,
      //     value: 'Prepaid',
      //   },
      //   {
      //     text: 'B10',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B10',
      //   },
      //   {
      //     text: 'B39',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B39',
      //   },
      //   {
      //     text: 'B49',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B49',
      //   },
      //   {
      //     text: 'B39_PLUS20',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B39_PLUS20',
      //   },
      //   {
      //     text: 'B39_PLUS50',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B39_PLUS50',
      //   },
      //   {
      //     text: 'B59E',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B59E',
      //   },
      //   {
      //     text: 'B59DB',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B59DB',
      //   },
      //   {
      //     text: 'B89DB',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B89DB',
      //   },
      //   {
      //     text: 'B54DB',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B54DB',
      //   },
      //   {
      //     text: 'NU',
      //     align: 'center',
      //     sortable: true,
      //     value: 'NU',
      //   },
      //   {
      //     text: 'B150',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B150',
      //   },
      //   {
      //     text: 'B39_FC',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B39_FC',
      //   },
      //   {
      //     text: 'TBG50',
      //     align: 'center',
      //     sortable: true,
      //     value: 'tbg50',
      //   },
      //   {
      //     text: 'B54DB_FC',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B54DB_FC',
      //   },
      //   {
      //     text: 'B59DB_FC',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B59DB_FC',
      //   },
      //   {
      //     text: 'B89DB_FC',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B89DB_FC',
      //   },
      //   {
      //     text: 'B150_FC',
      //     align: 'center',
      //     sortable: true,
      //     value: 'B150_FC',
      //   },
      //   {
      //     text: 'ONEFamily Main',
      //     align: 'center',
      //     sortable: true,
      //     value: 'onefmain',
      //   },
      //   {
      //     text: 'ONEFamily Sub',
      //     align: 'center',
      //     sortable: true,
      //     value: 'onefsub',
      //   },
      //   {
      //     text: 'MYSISWA35',
      //     align: 'center',
      //     sortable: true,
      //     value: 'mysiswa35',
      //   },
      //   {
      //     text: 'Total',
      //     align: 'right',
      //     sortable: true,
      //     value: 'total',
      //   },
      // ],
      reloadHeaders: [
        {
          text: 'Day',
          align: 'center',
          sortable: true,
          value: 'day',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailReloadHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Reload',
          align: 'center',
          sortable: true,
          value: 'reload',
        },
      ],
      recruitmentHeaders: [
        {
          text: 'Day',
          align: 'center',
          sortable: true,
          value: 'day',
        },
        {
          text: 'Total',
          align: 'center',
          sortable: true,
          value: 'total',
        },
      ],
      detailRecruitmentHeaders: [
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Recruitment',
          align: 'center',
          sortable: true,
          value: 'recruitment',
        },
      ],
      totalActivation: 0,
      totalReload: 0,
      totalRecruitment: 0,
    }
  },
  created: function () {
    !this.signageAdmin && this.getSignageTracking(this.thisMonth)
    this.signageAdmin && this.getSignageLocations()
  },
  computed: {
    signageAdmin () {
      const properties = security.me.getProperties()
      let admin = false

      properties.forEach(property => {
        if (property.name === 'dashboard.signage' && property.value === 'admin') {
          admin = true
        }
      })

      return admin
    },
    locationItems () {
      return [
        { location: 'All Location', code: 'all', leadDealer: 'All Dealers' },
        ...this.locations,
      ]
    },
  },
  watch: {
    location: function (location) {
      this.getSignageTracking(this.month, location.code)
    },
    month: function (month) {
      this.getSignageTracking(month)
    },
  },
  methods: {

    getSignageTracking: async function (month, code) {
      const params = code ? createGetParams({ month, code }) : createGetParams({ month })
      this.loading = true
      this.resetTotals()

      try {
        const response = await this.$rest.get('getSignageTracking.php', params)

        if (code === 'all') {
          // ✅ All Location: response.data IS the array of location blocks
          // (each block already carries its own activations/reloads/
          // recruitments), not a flat list of day-rows. Kept separate for
          // the export and the on-screen table is left empty (it's built
          // for single-location day-rows). Only dynamicPlans is derived
          // here, so export headers still line up with the plan columns.
          this.allLocationsData = response.data || []

          const sampleLocation = this.allLocationsData[0]
          const sampleRow = sampleLocation && sampleLocation.activations && sampleLocation.activations[0]

          if (sampleRow) {
            this.dynamicPlans = Object.keys(sampleRow).filter(key =>
              !['day', 'items', 'total'].includes(key),
            )
            this.activationHeaders = [
              { text: 'Day', align: 'center', value: 'day' },
              ...this.dynamicPlans.map(plan => ({
                text: plan,
                align: 'center',
                value: plan,
              })),
              { text: 'Total', align: 'right', value: 'total' },
            ]
          }

          this.loading = false
          return
        }

        const activations = response.data.activations

        // ✅ STEP 1: build dynamic plans
        if (activations.length > 0) {
          const sample = activations[0]

          this.dynamicPlans = Object.keys(sample).filter(key =>
            !['day', 'items', 'total'].includes(key),
          )

          // ✅ STEP 2: build headers dynamically
          this.activationHeaders = [
            { text: 'Day', align: 'center', value: 'day' },
            ...this.dynamicPlans.map(plan => ({
              text: plan,
              align: 'center',
              value: plan,
            })),
            { text: 'Total', align: 'right', value: 'total' },
          ]
        }

        // ✅ STEP 3: calculate totals dynamically
        this.totals = {}
        this.totalActivation = 0

        activations.forEach(activation => {
          this.dynamicPlans.forEach(plan => {
            this.totals[plan] = (this.totals[plan] || 0) + (activation[plan] || 0)
          })

          this.totalActivation += activation.total
        })

        // keep existing
        response.data.reloads.forEach(reload => {
          this.totalReload += reload.total * 1
        })

        response.data.recruitments.forEach(recruitment => {
          this.totalRecruitment += recruitment.total
        })

        this.activations = activations
        this.reloads = response.data.reloads
        this.recruitments = response.data.recruitments

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    resetTotals: function () {
      this.activations = this.reloads = this.recruitments = []
      this.allLocationsData = []
      this.dynamicPlans = []
      this.totals = {}
      this.totalActivation = this.totalReload = this.totalRecruitment = 0
    },
    getSignageLocations: async function () {
      const params = createGetParams({ list: true })
      try {
        const response = await this.$rest.get('getSignageLocations.php', params)
        this.locations = response.data
      } catch (error) {
        console.log(error)
      }
    },
    exportTracking (type) {
      if (this.location && this.location.code === 'all') {
        this.exportAllLocationsTracking(type)
        return
      }

      const data = []
      let headers = []
      let rows = []

      // ✅ ACTIVATION
      if (type === 'activation') {
        rows = this.activations
        headers = ['Day', ...this.dynamicPlans, 'Total']

        rows.forEach(obj => {
          data.push([
            obj.day,
            ...this.dynamicPlans.map(plan => obj[plan] || 0),
            obj.total,
          ])
        })
      }

      // ✅ RELOAD
      if (type === 'reload') {
        rows = this.reloads
        headers = ['Day', 'Total']

        rows.forEach(obj => {
          data.push([
            obj.day,
            obj.total,
          ])
        })
      }

      data.unshift(headers)

      // 🔥 USE leadDealer
      const dealerId = this.location?.leadDealer || 'ALL'

      // 🔥 MODE
      const mode = this.selectedWeek ? 'weekly' : 'monthly'

      // 🔥 MONTH
      const monthLabel = this.month

      // 🔥 WEEK LABEL
      let weekLabel = ''
      if (this.selectedWeek) {
        const label = this.weekOptions.find(
          w => w.value.from === this.selectedWeek.from,
        )?.label

        const match = label?.match(/Week\s(\d+)/)
        weekLabel = match ? `week${match[1]}` : 'week'
      }

      // 🔥 FINAL FILE NAME
      let fileName = ''

      if (mode === 'monthly') {
        fileName = `${type}_monthly_${monthLabel}_${dealerId}.xlsx`
      } else {
        fileName = `${type}_weekly_${monthLabel}_${weekLabel}_${dealerId}.xlsx`
      }

      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(wb, ws, 'Tracking')
      XLSX.writeFile(wb, fileName)
    },
    exportAllLocationsTracking (type) {
      const blocks = this.allLocationsData || []

      if (blocks.length === 0) {
        return
      }

      const data = []

      if (type === 'activation') {
        data.push(['No.', 'Company Name', ...this.dynamicPlans, 'Total'])

        const grand = {}
        this.dynamicPlans.forEach(plan => { grand[plan] = 0 })
        grand.total = 0

        blocks.forEach((block, idx) => {
          const totals = {}
          this.dynamicPlans.forEach(plan => { totals[plan] = 0 })
          let total = 0

      ;(block.activations || []).forEach(day => {
            this.dynamicPlans.forEach(plan => {
              totals[plan] += day[plan] || 0
            })
            total += day.total || 0
          })

          data.push([
            idx + 1,
            block.location,
            ...this.dynamicPlans.map(plan => totals[plan]),
            total,
          ])

          this.dynamicPlans.forEach(plan => { grand[plan] += totals[plan] })
          grand.total += total
        })

        data.push(['', 'TOTAL', ...this.dynamicPlans.map(plan => grand[plan]), grand.total])
      } else {
        // reload — one row per location, total reload
        data.push(['No.', 'Company Name', 'Total Reload'])

        let grandTotal = 0

        blocks.forEach((block, idx) => {
          const total = (block.reloads || []).reduce((sum, day) => sum + (parseFloat(day.total) || 0), 0)
          const rounded = Math.round(total * 100) / 100

          data.push([idx + 1, block.location, rounded])
          grandTotal += rounded
        })

        data.push(['', 'TOTAL', Math.round(grandTotal * 100) / 100])
      }

      const ws = XLSX.utils.aoa_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Summary')

      const fileName = `${type}_monthly_${this.month}_ALL.xlsx`

      XLSX.writeFile(wb, fileName)
    },
  },
}
</script>
